/* tslint:disable:max-line-length */
import localeNl from '@angular/common/locales/nl';
import localeNlExtra from '@angular/common/locales/extra/nl';
import {AccountCategoryService} from './services/account-category.service';
import {ActivateAccountComponent} from './components/authority/activate/activate-account.component';
import {AddAccountDialogComponent} from './components/account/add/add-account-dialog.component';
import {AddClientComponent} from './components/client/add/add-client.component';
import {AddRuleComponent} from './components/admin/rule/add/add-rule.component';
import {AddSecondUserComponent} from './components/second-user/add/add-second-user.component';
import {AdminGuard} from './services/security-services/guards/admin-guard.service';
import {AppComponent} from './app.component';
import {BreadcrumbComponent} from './components/breadcrumb/breadcrumb.component';
import {BreadcrumbService} from './services/breadcrumb.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {CategoriesComponent} from './components/admin/categories/categories.component';
import {ClickOutsideModule} from 'ng-click-outside';
import {ClientComponent} from './components/client/client.component';
import {ClientGuard} from './services/security-services/guards/client-guard.service';
import {ClientInviteDialogComponent} from './components/client/edit/invite/client-invite-dialog.component';
import {ClientOverviewComponent} from './components/admin/overview/client/client-overview.component';
import {ClientRevokeDialogComponent} from './components/client/edit/revoke/client-revoke-dialog.component';
import {ConfirmDialogComponent} from './components/shared/notification/confirm/confirm-dialog.component';
import {ConfirmDownloadFinalDialogComponent} from './components/report/confirm-download-final-dialog/confirm-download-final-dialog.component';
import {ContactComponent} from './components/contact/contact.component';
import {ContactService} from './services/contact.service';
import {CourtService} from './services/court.service';
import {CurrencyService} from './services/currency-service';
import {DocumentClickedService} from './services/document-clicked.service';
import {DragAndDropDirective} from './directives/drag-and-drop.directive';
import {EditClientComponent} from './components/client/edit/edit-client.component';
import {EditEmailComponent} from './components/user/edit-email/edit-email.component';
import {EditSecondUserComponent} from './components/second-user/edit/edit-second-user.component';
import {EditUserComponent} from './components/user/edit/edit-user.component';
import {EmailIsChangedComponent} from './components/user/edit-email/email-is-changed/email-is-changed.component';
import {ErrorStateMatcher, ShowOnDirtyErrorStateMatcher} from '@angular/material/core';
import {ErvoDialogComponent} from './components/report/list/ervo-dialog/ervo-dialog.component';
import {FileUploadService} from './services/file-upload.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {ImportComponent} from './components/import/import.component';
import {ImportDetailsDialogComponent} from './components/import/import-details-dialog/import-details-dialog.component';
import {InformDialogComponent} from './components/shared/notification/inform/inform-dialog.component';
import {InvoiceOverviewComponent} from './components/admin/overview/invoice/invoice-overview.component';
import {InvoiceService} from './services/invoice.service';
import {ListAccountComponent} from './components/account/list/list-account.component';
import {ListClientComponent} from './components/client/list/list-client.component';
import {ListInvoiceComponent} from './components/invoice/list-invoice.component';
import {LoginComponent} from './components/authority/login/login.component';
import {MaterialModule} from './material.module';
import {MatPaginationIntlService} from './services/MatPaginationIntlService';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {MigrationService} from './services/migration.service';
import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {NgxUiLoaderModule} from 'ngx-ui-loader';
import {NotificationDialogComponent} from './components/notification/notification-dialog.component';
import {NotificationService} from './services/notification.service';
import {OptionComponent} from './components/shared/select/option/option.component';
import {OtherTransactionListComponent} from './components/report/other-transaction-list/other-transaction-list.component';
import {PasswordVerificationDialogComponent} from './components/shared/password-protection/password-verification-dialog.component';
import {PasswordVerificationService} from './services/password-verification.service';
import {PaymentFailedComponent} from './components/payment/payment-failed/payment-failed.component';
import {PaymentSucceededComponent} from './components/payment/payment-succeeded/payment-succeeded.component';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {PendingChangesGuard} from './services/security-services/guards/unsaved-changes-guard.service';
import {ProgressComponent} from './components/import/progress/progress.component';
import {QuestionComponent} from './components/report/question/question.component';
import {RecoverPasswordComponent} from './components/authority/recover-password/recover-password.component';
import {RegisterComponent} from './components/authority/register/register.component';
import {registerLocaleData} from '@angular/common';
import {ReplacePipe} from './components/report/replace.pipe';
import {ReportComponent} from './components/report/report.component';
import {ReportListComponent} from './components/report/list/report-list.component';
import {ReportListFinalComponent} from './components/report/list-finished/report-list-final.component';
import {ReportListItemComponent} from './components/report/list/report-list-item/report-list-item.component';
import {ReportOverviewComponent} from './components/admin/overview/report/report-overview.component';
import {ReportPreviewDialogComponent} from './components/report/report-preview-dialog/report-preview-dialog.component';
import {ReportService} from './services/report.service';
import {RouterModule, Routes} from '@angular/router';
import {RuleComponent} from './components/admin/rule/rule.component';
import {ScriptService} from './services/script-service/script-service';
import {SelectComponent} from './components/shared/select/select.component';
import {SelectPaymentMethodComponent} from './components/payment/select-payment-method/select-payment-method.component';
import {SetNewPasswordComponent} from './components/authority/recover-password/set-new-password/set-new-password.component';
import {ShouldPreviewService} from './services/should-preview-service';
import {ShowPasswordToggleDirective} from './directives/show-password-toggle.directive';
import {SpecialCharacterDirective} from './components/report/special-characters.directive';
import {SubcategoryPickerComponent} from './components/transaction/subcategory-picker/subcategory-picker.component';
import {TaskComponent} from './components/task/task.component';
import {TaskListComponent} from './components/task/list/task-list.component';
import {TaskService} from './services/task.service';
import {ToastrModule} from 'ngx-toastr';
import {TokenInterceptorService} from './services/security-services/token-interceptor.service';
import {TransactionAssignedComponent} from './components/transaction/assigned/transaction-assigned.component';
import {TransactionComponent} from './components/transaction/transaction.component';
import {TransactionUnassignedComponent} from './components/transaction/unassigned/transaction-unassigned.component';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {UnsavedChangesDialogComponent} from './components/report/unsaved-changes-dialog/unsaved-changes-dialog.component';
import {UserGuard} from './services/security-services/guards/user-guard.service';
import {UserService} from './services/user.service';
import {UitlegBanktransactiesDownloadenComponent} from './components/import/transacties-downloaden/uitleg-banktransacties-downloaden.component';
import {SecondUserGuard} from './services/security-services/guards/second-user-guard.service';
import {DiscountPriceComponent} from './components/shared/discount-price/discount-price.component';
import {ManualImportComponent} from './components/import/manual-import/manual-import.component';
import {AddManualAccountComponent} from './components/account/add-manual-account/add-manual-account.component';
import {ConfirmAddSupportedBankDialogComponent} from './components/account/add-manual-account/confirm-add-supported-bank-dialog/confirm-add-supported-bank-dialog.component';
import {ChooseBankComponent} from './components/import/choose-bank/choose-bank.component';
import {IbanValidatorDirective} from './validators/directives/iban-validator.directive';
import {BiggerScreenRequiredComponent} from './components/shared/bigger-screen-required/bigger-screen-required.component';
import {EditReportListComponent} from './components/report/list/edit-report-list/edit-report-list.component';
import {DebuggingComponent} from './components/debugging/debugging.component';
import {DebuggingService} from './services/debugging.service';
import {TaskOverviewComponent} from './components/admin/overview/task/task-overview.component';
import {AccountDebuggingComponent} from './components/account/debugging/account-debugging.component';
import {StatementService} from './services/statement.service';
import {OtherTransactionListWrapperComponent} from './components/report/other-transaction-list-wrapper/other-transaction-list-wrapper.component';


registerLocaleData(localeNl, 'fr-FR', localeNlExtra);

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const routes: Routes = [

  // Authority
  {path: 'login', component: LoginComponent},
  {path: 'registreren', component: RegisterComponent},
  {path: 'wachtwoord-herstel', component: RecoverPasswordComponent},
  {path: 'wachtwoord-herstel/:key', component: SetNewPasswordComponent},
  {path: 'activatie/:userId', component: ActivateAccountComponent},

  // User
  {path: 'account-gegevens-bewerken', component: EditUserComponent, canActivate: [UserGuard]},
  {path: 'e-mailadres-aanpassen', component: EditEmailComponent, canActivate: [UserGuard]},
  {path: 'e-mailadres-aanpassen/gelukt', component: EmailIsChangedComponent},
  {path: 'facturen', component: ListInvoiceComponent, canActivate: [UserGuard]},

  // Clients
  {path: '', component: ListClientComponent, canActivate: [UserGuard]},
  {path: 'bewind/toevoegen', component: AddClientComponent, canActivate: [UserGuard]},
  {path: 'bewind/:clientId', component: ClientComponent, canActivate: [UserGuard]},
  {path: 'bewind/:clientId/bewerken', component: EditClientComponent, canActivate: [UserGuard]},
  {path: 'bewind/:clientId/tweede-bewindvoerder/toevoegen', component: AddSecondUserComponent, canActivate: [UserGuard]},
  {path: 'bewind/:clientId/tweede-bewindvoerder/bewerken', component: EditSecondUserComponent, canActivate: [UserGuard]},
  {path: 'bewind/:clientId/importeren', component: ChooseBankComponent, canActivate: [UserGuard]},
  {path: 'bewind/:clientId/importeren/:bank', component: ImportComponent, canActivate: [UserGuard]},
  {path: 'bewind/:clientId/handmatig-rekening-toevoegen', component: AddManualAccountComponent, canActivate: [UserGuard]},
  {path: 'bewind/:clientId/rapportage/bewerken', component: EditReportListComponent, canActivate: [AdminGuard]},
  {path: 'bewind/:clientId/rapportage/:reportType', component: ReportComponent, canActivate: [UserGuard], canDeactivate: [PendingChangesGuard]},
  {path: 'bewind/:clientId/rapportage/:reportType/:year', component: ReportComponent, canActivate: [UserGuard], canDeactivate: [PendingChangesGuard]},
  {path: 'bewind/:clientId/rapportage', component: ReportListComponent, canActivate: [UserGuard]},
  {path: 'bewind/:clientId/debugging/:reportType', component: DebuggingComponent, canActivate: [AdminGuard]},
  {path: 'bewind/:clientId/debugging/:reportType/:year', component: DebuggingComponent, canActivate: [AdminGuard]},
  {path: 'bewind/:clientId/overige-inkomsten-en-uitgaven/:reportId', component: OtherTransactionListWrapperComponent, canActivate: [UserGuard]},



  // Payments
  {path: 'selecteer-betaalmethode/:clientId/:reportId', component: SelectPaymentMethodComponent},
  {path: 'betaling-gelukt/:reportId', component: PaymentSucceededComponent},
  {path: 'betaling-mislukt/:reportId', component: PaymentFailedComponent},

  // client user
  {path: 'rapportage/definitief', component: ReportListFinalComponent},

  // Account
  {path: 'rekening/:accountId', component: TransactionComponent, canActivate: [UserGuard]},
  {path: 'leefgeldrekening/:accountId', component: TransactionComponent, canActivate: [UserGuard]},
  {path: 'rekening/:accountId/handmatig-transacties-toevoegen', component: ManualImportComponent, canActivate: [UserGuard]},
  {path: 'rekening/:accountId/debugging', component: AccountDebuggingComponent, canActivate: [AdminGuard]},
  {path: 'leefgeldrekening/:accountId/debugging', component: AccountDebuggingComponent, canActivate: [AdminGuard]},


  // Other
  {path: 'categorieen', component: CategoriesComponent, canActivate: [AdminGuard]},
  {path: 'regels', component: RuleComponent, canActivate: [AdminGuard]},
  {path: 'regels/toevoegen', component: AddRuleComponent, canActivate: [AdminGuard]},
  {path: 'contact', component: ContactComponent},

  // Overviews
  {path: 'overzichten/bewinden', component: ClientOverviewComponent, canActivate: [AdminGuard]},
  {path: 'overzichten/rapporten', component: ReportOverviewComponent, canActivate: [AdminGuard]},
  {path: 'overzichten/facturen', component: InvoiceOverviewComponent, canActivate: [AdminGuard]},
  {path: 'overzichten/taken', component: TaskOverviewComponent, canActivate: [AdminGuard]},

];

@NgModule({
  schemas: [
    NO_ERRORS_SCHEMA
  ],
  declarations: [
    ActivateAccountComponent,
    AddAccountDialogComponent,
    AddClientComponent,
    AddRuleComponent,
    AddSecondUserComponent,
    AppComponent,
    BreadcrumbComponent,
    CategoriesComponent,
    ClientComponent,
    ClientInviteDialogComponent,
    ClientOverviewComponent,
    ClientRevokeDialogComponent,
    ConfirmDialogComponent,
    ConfirmDownloadFinalDialogComponent,
    ContactComponent,
    DragAndDropDirective,
    EditClientComponent,
    EditEmailComponent,
    EditSecondUserComponent,
    EditUserComponent,
    EmailIsChangedComponent,
    ErvoDialogComponent,
    ImportComponent,
    ImportDetailsDialogComponent,
    AccountDebuggingComponent,
    ManualImportComponent,
    InformDialogComponent,
    InvoiceOverviewComponent,
    ListAccountComponent,
    ListClientComponent,
    ListInvoiceComponent,
    LoginComponent,
    NotificationDialogComponent,
    OptionComponent,
    OtherTransactionListComponent,
    PasswordVerificationDialogComponent,
    PaymentFailedComponent,
    PaymentSucceededComponent,
    ProgressComponent,
    QuestionComponent,
    RecoverPasswordComponent,
    RegisterComponent,
    ReplacePipe,
    ReportComponent,
    ReportListComponent,
    ReportListFinalComponent,
    ReportListItemComponent,
    ReportOverviewComponent,
    ReportPreviewDialogComponent,
    RuleComponent,
    SelectComponent,
    SelectPaymentMethodComponent,
    SetNewPasswordComponent,
    ShowPasswordToggleDirective,
    IbanValidatorDirective,
    SpecialCharacterDirective,
    SubcategoryPickerComponent,
    TaskComponent,
    TaskListComponent,
    TransactionAssignedComponent,
    TransactionComponent,
    TransactionUnassignedComponent,
    UnsavedChangesDialogComponent,
    UitlegBanktransactiesDownloadenComponent,
    DiscountPriceComponent,
    AddManualAccountComponent,
    ConfirmAddSupportedBankDialogComponent,
    ChooseBankComponent,
    BiggerScreenRequiredComponent,
    EditReportListComponent,
    DebuggingComponent,
    TaskOverviewComponent,
    OtherTransactionListWrapperComponent
  ],
  imports: [
    RouterModule,
    NgxUiLoaderModule,
    ClickOutsideModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    MaterialModule,
    ReactiveFormsModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    PdfViewerModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(
      routes,
      {
        useHash: true,
        enableTracing: false,
        relativeLinkResolution: 'legacy',
        scrollPositionRestoration: 'top'
      }
    ),
    ToastrModule.forRoot()
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    },
    CurrencyService,
    ShouldPreviewService,
    ScriptService,
    ContactService,
    MigrationService,
    UserGuard,
    ClientGuard,
    SecondUserGuard,
    AdminGuard,
    PendingChangesGuard,
    UserService,
    FileUploadService,
    CourtService,
    AccountCategoryService,
    ReportService,
    TaskService,
    InvoiceService,
    BreadcrumbService,
    PasswordVerificationService,
    NotificationService,
    DocumentClickedService,
    DebuggingService,
    StatementService,
    {provide: MatPaginatorIntl, useClass: MatPaginationIntlService },
    {provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher},
  ],
  bootstrap: [
    AppComponent
  ],
})
export class AppModule {
}
